import Client from './Client';

export default class AgencyClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取机构列表
   */
  async getList(data) {
    const res = await this.client.post('/api/agency/pageAgency', data);
    return res;
  }

  /**
   * 禁用/启用机构
   * @param
   * identityId id
   * identityValid 10 30
   */
  async updateAgencyValid(data) {
    const res = await this.client.post('/api/agency/updateAgencyValid', data);
    return res;
  }

  /**
   * info
   * @param
   * id
   */
  async getInfo(agencyId) {
    const res = await this.client.post(`/api/agency/getAgencyDetail?agencyId=${agencyId}`);
    return res;
  }

  /**
   * 设置收款权限
   *
   */
  async updateIsReceiveAccount(data) {
    const res = await this.client.post('/api/agency/updateIsReceiveAccount', data);
    return res;
  }

  /**
   * 删除机构人员
   *
   */
  async deleteAgencyIdentity(data) {
    const res = await this.client.post('/api/agency/deleteAgencyIdentity', data);
    return res;
  }

  /**
   * 删除机构人员
   *
   */
  async insertAgencyIdentity(data) {
    const res = await this.client.post('/api/agency/InsertAgencyIdentity', data);
    return res;
  }

  /**
   * 新增编辑机构
   *
   */
  async upsertAgency(data) {
    const res = await this.client.post('/api/agency/upsertAgency', data);
    return res;
  }

  /**
   * 修改机构对应代理商
   *
   */
  async upsertAgent(data) {
    const res = await this.client.post('/api/agency/updateAgent', data);
    return res;
  }
}